var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocStopoverFlag4WhiteC82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / navi / soc_stopover_flag_4_white_C8.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-navi-/-soc_stopover_flag_4_white_C8.2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "004_Icons-/-Charging_Power_and_Electricity-/-soc_destination_blank_stopover_flag",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,2 L16,6 L22,6 L22,46 L2,46 L2,6 L8,6 L8,2 L16,2 Z M20,8 L4,8 L4,44 L20,44 L20,8 Z M18,18 L18,42 L6,42 L6,18 L18,18 Z",
    id: "battery"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,20 L29,46 L27,46 L27,20 L29,20 Z M31,20 L46,27.5 L31,32 L31,20 Z",
    id: "soc_destination_4_stopover_flag"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocStopoverFlag4WhiteC82);
export default __webpack_public_path__ + "static/media/soc_stopover_flag_4_white_C8.2.faca91371dd7fddfbb03256009499b6c.svg";
export { ForwardRef as ReactComponent };